module.exports = __webpack_public_path__ + "images/vr-headset-1-0dc28ec336602a20c1db721621731d24.jpg";